module.exports = __webpack_public_path__ + "0b6587486f342eac940a65c256ae8d71-811_logo_2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/assets/811_logo_2x.png
// module id = 233
// module chunks = 0